import { render, staticRenderFns } from "./CardReintegro.vue?vue&type=template&id=3d49c28b"
import script from "./CardReintegro.vue?vue&type=script&lang=ts"
export * from "./CardReintegro.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d49c28b')) {
      api.createRecord('3d49c28b', component.options)
    } else {
      api.reload('3d49c28b', component.options)
    }
    module.hot.accept("./CardReintegro.vue?vue&type=template&id=3d49c28b", function () {
      api.rerender('3d49c28b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CardReintegro.vue"
export default component.exports